import classNames from 'classnames';
import { CopyIcon } from '../icons';
import { copyTextToClipBoard } from '../utils';
import { Skeleton } from './Skeleton';

export interface StatisticItem {
  name: string;
  value: string | number;
  currency?: string;
  className?: string;
}

export interface BlockStatisticsWithCopyProps {
  items: StatisticItem[];
  withBorder?: boolean;
  withPaddingX?: boolean;
  isFetching?: boolean;
}

export const BlockStatisticsWithCopy = ({
  withBorder = false,
  withPaddingX = true,
  isFetching = false,
  items,
}: BlockStatisticsWithCopyProps) => {
  return (
    <div
      className={classNames('w-full flex flex-wrap items-center justify-between', {
        'border border-gray-200 rounded-xl': withBorder,
      })}
    >
      {items?.map((item, i, all) => (
        <div
          key={i}
          className={classNames(
            'my-3 md:w-1/5 w-full flex gap-4 justify-between items-start font-[Inter] relative group/block border-gray-200',
            {
              'px-4': withPaddingX,
              'md:border-r md:border-b-transparent md:border-b-0 border-b': i < all.length - 1,
              'border-r md:border-r-gray-200 border-r-transparent ': i > 0 && i < all.length - 1,
            },
          )}
        >
          <div className="flex flex-col gap-1 w-full">
            <div className="text-xs leading-5 text-[#737373]">{item.name}</div>
            {isFetching ? (
              <Skeleton width={'70%'} height={28} />
            ) : (
              <span className={classNames('flex items-baseline text-nowrap gap-1', item.className)}>
                <span className="text-xl">{item.value}</span>
                {item.currency && (
                  <span
                    className={classNames('text-xs', {
                      'text-gray-500': !item?.className?.includes('text-'),
                    })}
                  >
                    {item.currency}
                  </span>
                )}
              </span>
            )}
          </div>

          {!isFetching && (
            <div className="group-hover/block:block hidden absolute right-2 bottom-2">
              <span
                className="cursor-pointer hover:opacity-70"
                onClick={() =>
                  copyTextToClipBoard(String(item.value + (item.currency || '')), {
                    successMessage: 'Copied successfully',
                  })
                }
              >
                <img src={CopyIcon} alt="Copy" className="w-6 h-6 min-w-6 min-h-6 " />
              </span>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};
